import React from 'react';
import { ShieldIcon } from 'lucide-react';
const Guarantee = () => {
  return <div className="w-full bg-[#DEEFE1] py-16" data-id="element-172">
      <div className="container mx-auto px-4" data-id="element-173">
        <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-lg p-8 flex flex-col md:flex-row items-center gap-8" data-id="element-174">
          <div className="w-24 h-24 bg-[#FAFFFB] rounded-full flex-shrink-0 flex items-center justify-center" data-id="element-175">
            <ShieldIcon className="w-12 h-12 text-[#438A52]" data-id="element-176" />
          </div>
          <div className="text-center md:text-left" data-id="element-177">
            <h3 className="text-2xl font-bold text-gray-800 mb-3" data-id="element-178">
              Garantía de satisfacción de 7 días
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-179">
              Si después de probar nuestras recetas y seguir el sistema durante
              7 días no estás 100% satisfecha, simplemente envíanos un email y
              te devolveremos tu dinero completo. Sin preguntas, sin
              complicaciones.
            </p>
            <p className="font-medium text-[#438A52]" data-id="element-180">
              No hay riesgo para ti — queremos que estés completamente feliz con
              tu compra.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default Guarantee;